//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import PosCustomerReceivablePaymentListView from "@/views/POS/PosCustomerReceivablePayment/list"

//
export default {
  path: "pos_customer_receivable_payment",
  component: ModuleLayout,
  children: [
    {
      name: "pos-customer-receivable-payment-list",
      path: "",
      component: PosCustomerReceivablePaymentListView,
    },
  ],
  meta: {
    title: "Pagos de clientes"
  },
}